import React, { Component } from 'react';

class Dialpad extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                {/* <ziwo-dialpad autorun="true"></ziwo-dialpad> */}
            </div>
        );
    }
}

export default Dialpad;